export default {"src":"/_next/static/image/public/images/Track_your_order.e3189c5dab42530d5593214345cba659.svg","height":106,"width":180};